import { TileButton } from '@/components/buttons/tile/component';
import { PrimaryLayout } from '@/layouts/primary';
import { Flex, Grid } from '@mantine/core';
import {
	IconLayoutGridAdd,
	IconShoppingCart,
	IconTrophy,
	IconZoomQuestion,
} from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { NewsAndArticles } from './news-and-articles';
import styles from './styles.module.css';
import { User } from './user';

export const HomePage = () => {
	const navigate = useNavigate();
	const goToScanBag = () => navigate({ to: '/scan-bag' });
	const goToRewards = () => navigate({ to: '/rewards' });
	const goToShop = () => navigate({ to: '/shop' });
	const goToHelp = () => navigate({ to: '/help' });

	return (
		<PrimaryLayout bottomNav="home">
			<Flex justify="center" align="center" direction="column" gap="md" className={styles.header} />
			<Flex justify="center" align="center" direction="column" gap="md" px="lg" py="0" pb="lg">
				<Grid>
					<Grid.Col span={12}>
						<User />
					</Grid.Col>
					<Grid.Col span={6}>
						<TileButton icon={IconLayoutGridAdd} text="Scan a QR Code" onClick={goToScanBag} />
					</Grid.Col>
					<Grid.Col span={6}>
						<TileButton icon={IconShoppingCart} text="Order" onClick={goToShop} />
					</Grid.Col>
					<Grid.Col span={6}>
						<TileButton icon={IconTrophy} text="Rewards" onClick={goToRewards} />
					</Grid.Col>
					<Grid.Col span={6}>
						<TileButton icon={IconZoomQuestion} text="Get Help" onClick={goToHelp} />
					</Grid.Col>
				</Grid>
			</Flex>
			<NewsAndArticles />
		</PrimaryLayout>
	);
};
